enum RegistrationPersonalPivots {
    AboutYou = "About you",
    Verification = "Verification",
}

export default RegistrationPersonalPivots;